import { Typography } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC } from 'react';
import SummaryLine from '../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { ABSCHLUSS_DESCRIPTION } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { DisplayDateTime, DisplayEuro } from '../../../../../../utils/formats';
import AbschlussSeiteBox, { AbschlussSeiteHochladeFeldBox, FinaleSchrittInfoBoxMittelabruf } from '../../../antrag-components/AbschlussSeiteBox';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
// import KostenPositionSchema from '../../../../../../lib/paths/kostenposition_FULL_Paths.json';
import Schema from '../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
const P = Schema.attributes;
// const KP_P = KostenPositionSchema.attributes;

const AbschlussMittelabruf: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	// const [loading, setLoading] = useState(false);

	// const handleCreateVerwendungsnachweis = async () => {
	// 	const allKostenPosition = get(application, P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []);
	// 	const allVerbundPartner = get(application, P.Foerderantrag.schema.attributes.Verbundpartner.path, []);
	// 	const VN_DATA = {
	// 		Allgemein_Haushaltsjahr: get(application, P.Allgemein_Haushaltsjahr.path),
	// 		Verwendungsnachweisstatus_Status: ANTRAGS_STATUS.inBearbeitung,
	// 		Foerderantrag: get(application, `${P.Foerderantrag.path}.id`),
	// 		Mittelabruf: get(application, 'id'),
	// 		Allgemein_Foerderquote_Antragstellerin: get(
	// 			application,
	// 			P.Foerderantrag.schema.attributes.Antragstellende_Organisation_Foerderquote.path,
	// 			[]
	// 		).find((ele: any) => get(ele, 'Projektjahr') === get(application, P.Allgemein_Haushaltsjahr.path))?.Foerderquote_403741,
	// 		Allgemein_Foerderquote_Projektpartner: [
	// 			...allVerbundPartner.map((eachVPartner: any) => {
	// 				return {
	// 					Partner: get(eachVPartner, 'Verbundpartner.id'),
	// 					Partner_Quote: get(eachVPartner, ANTRAG_VERBUNDPARTNER.FoerderQuoteBlock, []).find(
	// 						(ele: any) => get(ele, 'Projektjahr') === get(application, P.Allgemein_Haushaltsjahr.path)
	// 					)?.Foerderquote_403741,
	// 				};
	// 			}),
	// 		],
	// 	};

	// 	try {
	// 		setLoading(true);
	// 		const vnRes = await PostRecord(APIS.Verwendungsnachweis, { data: VN_DATA });
	// 		if (vnRes) {
	// 			for (let i = 0; i < allKostenPosition.length; i++) {
	// 				const eachKP = allKostenPosition[i];
	// 				const NW_DATA = {
	// 					Allgemein_Nr: i + 1,
	// 					Allgemein_Kostentraeger: get(eachKP, KP_P.Allgemein_Kostentraeger.path),
	// 					Allgemein_Unternehmen_Institution: get(eachKP, `${KP_P.Unternehmen.path}.id`),
	// 					Verwendungsnachweis: get(vnRes, 'data.id'),
	// 					Allgemein_Kostenposition: get(eachKP, 'id'),
	// 					Allgemein_Kostenart: get(eachKP, KP_P.Allgemein_Kostenposition.path),
	// 					Allgemein_Bezeichnung: get(eachKP, KP_P.Allgemein_Bezeichnung.path),
	// 					Kostennachweise_Nachweise: [{ Kommentar: '' }],
	// 					Stundennachweis_Geleistete_Stunden: MONAT_LISTE,
	// 				};
	// 				console.log(' NW_DATA ', NW_DATA);
	// 				await PostRecord(APIS.Nachweisposition, { data: NW_DATA });
	// 			}
	// 		}
	// 	} catch (err: any) {
	// 		console.error('ERROR: Creating Verweundungsnachweis ', err);
	// 	} finally {
	// 		await saveApplication(false, application);
	// 		setLoading(false);
	// 	}
	// };

	return (
		<>
			<ApplicationHeading title='Mittelabruf Übersicht' description={ABSCHLUSS_DESCRIPTION} />

			<AbschlussSeiteBox>
				<Typography variant='h6'> Mittelabrufdaten</Typography>

				<SummaryLine
					label='Datum der Einreichung'
					value={
						get(application, P.Allgemein_Eingereicht_Am.path) ?
							DisplayDateTime(get(application, P.Allgemein_Eingereicht_Am.path))
						:	'noch nicht eingereicht'
					}
				/>
				<SummaryLine label='Projekttitel' value={get(application, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')} />
				<SummaryLine
					label='Zuwendungsfähige Ausgaben:'
					value={DisplayEuro(get(application, P.Ermittlung_Des_Auszahlungsbetrages_Zuwendungsfaehige_Ausgaben.path, ''))}
				/>
				<SummaryLine
					label='Zuwendung anteilig:'
					value={DisplayEuro(get(application, P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path, ''))}
				/>
				<SummaryLine
					label='abzüglich bereits abgerufenen Zuwendungen im gleichen Projektjahr:'
					value={DisplayEuro(get(application, P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, ''))}
				/>
				<SummaryLine
					label='Anforderungsbetrag:'
					value={DisplayEuro(get(application, P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path, ''))}
				/>
				<FinaleSchrittInfoBoxMittelabruf />
				<AbschlussSeiteHochladeFeldBox>
					<CreateForm
						formStruc={formStrucMittelAbrufHochladen()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</AbschlussSeiteHochladeFeldBox>

				{/* {isObjectEmpty(get(application, P.Mittelabruf_Verwendungsnachweiss.path, {})) && (
					<Stack spacing={2} sx={{ mt: '1rem' }}>
						<MUIAlert
							infoType={'info'}
							title='Achtung!'
							message={
								<>
									Zu jedem Mittelabruf ist es erforderlich, einen Verwendungsnachweis beizufügen. <br />
									In diesem Förderprogramm haben Sie die Möglichkeit, den Verwendungsnachweis auch zu einem späteren Zeitpunkt nachzureichen.
									Alternativ können Sie hier direkt einen Verwendungsnachweis für diesen Mittelabruf erstellen
								</>
							}
						/>
						<Button onClick={handleCreateVerwendungsnachweis}> Verwendungsnachweis erstellen</Button>
					</Stack>
				)} */}
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussMittelabruf;

const formStrucMittelAbrufHochladen = () => {
	let stru: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Eingereichter_Mittelabruf, hideLabel: true }],
			userProps: { columnToDivide: 1 },
		},
	];

	return stru;
};

export const getFormStrucAbschlussMittelabruf = () => {
	return concat(formStrucMittelAbrufHochladen());
};
